export function getCarbonFinesForecastData(buildings: BriefBuilding[]) {
    const carbonFinesForecastData = buildings.flatMap((building) => {
        if (!building.baselineCrp?.carbonPolicyCosts) {
            return [];
        }
        return building.baselineCrp?.carbonPolicyCosts.map((carbonPolicyCost) => ({
            policyId: carbonPolicyCost.policyId,
            policyName: carbonPolicyCost.policyName,
            policyYear: carbonPolicyCost.year,
            city: building.city,
            stateProvince: building.stateProvince,
            buildingArchetype: building.buildingArchetype,
            propertyName: building.propertyName,
            fundName: building.fundName,
            grossFloorArea: building.grossFloorArea,
            carbonFinesUnsaveable: carbonPolicyCost.cost,
        }));
    });
    return Object.values(carbonFinesForecastData);
}
